﻿export enum BusinessResultStatus {
    Unknown = 0,
    Success = 1,
    Warning = 2,
    Failure = 3,
    AuthorityFailure = 4,
    ValidationError = 5,
    NotFound = 6
}

export interface IBusinessFieldError {
    name: string,
    code: string,
    message: string
}

export interface IBusinessResult {
    id: string;
    time: number;
    status: BusinessResultStatus;
    code: string
    message: string;
    fieldErrors?: IBusinessFieldError[]
    data?: any;
}

export interface IBusinessDataResult<DataType> extends IBusinessResult {
    data?: DataType;
}